import { Box, Button, FileInput, Image, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core';
import React, { memo, useEffect, useState } from 'react';
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageProductsCategory.module.css'

const AddCategory = () => {
    const navigate = useNavigate();
    const [verticals, setVerticals] = useState<any[]>([]);
    const [value, setValue] = useState<any>('');
    const [selectedVertical, setSelectedVertical] = useState<any>();
    const [categoryName, setCategoryName] = useState<string>('');
    const [imageUrl, setImageUrl] = useState<string>('');
    const [preview, setPreview] = useState<string | null>(null);
    const [errors, setErrors] = useState<Record<string, string>>({}); // Stores all errors dynamically

    const token = localStorage.getItem("token");
    const updatedUrl = baseUrl.replace("/api/", "");
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST';
    const url = id ? `${baseUrl}admin/categories/update/${id}` : `${baseUrl}admin/categories/add`;

    const formData = new FormData();
    if (value) formData.append("category_icon", value);
    formData.append("vertical_id", selectedVertical);
    formData.append("category_name", categoryName,);

    const { data: getData, fetchData: getVerticals } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });

    const { data: datacategoryid, loading: categoryLoading, fetchData: getCategories } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });

    const { data: datacategory, error: postError, fetchData: postcategory } = useFetch({
        method: method,
        referrerPolicy: "no-referrer",
        headers: {
            "Access-Control-Allow-Origin": "*",
            "token": token,
        },
        body: formData,
    });

    useEffect(() => {
        getVerticals(`${baseUrl}admin/verticals`);
        if (id) {
            getCategories(`${baseUrl}admin/categories/${id}?status=1`);
        }
    }, []);

    useEffect(() => {
        if (datacategoryid?.data?.rows?.length && verticals?.length) {
            setCategoryName(datacategoryid.data.rows[0].category_name);
            const matchingVertical = verticals.find((v: any) => v.label === datacategoryid.data.rows[0].Vertical?.vertical_name);
            setSelectedVertical(matchingVertical?.value || null);
            setImageUrl(datacategoryid.data.rows[0].category_icon)
        }
    }, [datacategoryid, verticals]);

    useEffect(() => {
        if (getData?.data?.rows) {
            setVerticals(
                getData.data.rows.map((el: any) => ({
                    value: el.vertical_id.toString(),
                    label: el.vertical_name,
                }))
            );
        }
    }, [getData]);
    useEffect(() => {
        if (value) {
            const objectUrl = URL.createObjectURL(value);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl); // Cleanup
        }
    }, [value]);

    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | File | null) => {
        if (field === "category_name") {
            setCategoryName(value as string);
        } else if (field === "vertical_id") {
            setSelectedVertical(value);
        } else if (field === "vertical_icon") {
            setValue(value as File); // Ensure value is stored as a File object
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!categoryName.trim()) {
            newErrors.category_name = "Sub Category Name is Required";
        }
        if (!selectedVertical) {
            newErrors.vertical_id = "Category Name is Required";
        }
        if (!id) {
            if (!value) {
                newErrors.vertical_icon = "Category Icon is Required";
            } else if (!(value instanceof File)) {
                newErrors.vertical_icon = "Invalid file format";
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return; // Stop if validation fails
        await postcategory(url);
    };

    useEffect(() => {
        const showNotification = (type: 'success' | 'error', message: string) => {
            notifications.show({
                title: type === 'success' ? 'Success' : 'Error',
                message,
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (datacategory) {
            if (datacategory?.errors || postError) {
                showNotification('error', datacategory?.message || postError?.message || 'Something went wrong');
                return;
            }

            if (!postError && !datacategory?.errors) {
                showNotification('success', datacategory?.message || postError?.message || 'Sub Category Added Succesfully ');
                navigate('/manage-products-category');
            }
        }
    }, [datacategory, postError, navigate, classes]);

    return (
        <>
            <LoadingOverlay
                visible={categoryLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Sub Category</Title>
                    <Space h="lg" />
                    <Text>Sub Categories Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <Select
                            label="Select Category"
                            withAsterisk
                            placeholder="Choose Category"
                            data={verticals}
                            variant='filled'
                            searchable
                            radius={6}
                            maxDropdownHeight={200}
                            value={selectedVertical}
                            onChange={(value) => handleChange("vertical_id", value)}
                            error={errors.vertical_id}
                        />
                        <TextInput
                            value={categoryName}
                            onChange={(e) => handleChange("category_name", e.target.value)}
                            label="Sub Category name"
                            variant='filled'
                            withAsterisk
                            placeholder="Sub Category name"
                            radius={6}
                            error={errors.category_name}
                        />
                        <FileInput
                            label="Upload icon"
                            withAsterisk={id ? false : true}
                            variant="filled"
                            placeholder="Upload icon"
                            value={value}
                            onChange={(file) => handleChange("vertical_icon", file)}
                            radius={6}
                            error={errors.vertical_icon}
                        />
                        {preview ? (
                            <Box className={classes.verticalslogo}>
                                <Image fit="contain" src={preview} alt="icon" />
                            </Box>
                        ) : id ? <Box className={classes.verticalslogo}>
                            <Image fit="contain" src={`${updatedUrl}${imageUrl}`} alt="icon" />
                        </Box> : null}
                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button variant="default" radius={6} onClick={() => navigate('/manage-products-category')}>
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    );
};

export default memo(AddCategory);
